import store from "../../../store";
import {getImpersonatedTokens} from "../repository/ChangeUserRepository";
import {logInToApplicationByToken} from "../../../services/ApplicationService";
import router from "../../../core/router";

export default {
    beforeRouteEnter(to) {
        let contextApp = store.state.context.app;
        let continueUrl = store.state.context.continueUrl;

        getImpersonatedTokens(to.params.uuid,contextApp.uuid)
            .then(({data}) => {
                store.dispatch('Auth/onValidTokenReceived', data.contextToken)
                    .then(() => logInToApplicationByToken(contextApp, continueUrl, data.requestedToken));
            })
            .catch(() => {
                if (continueUrl) {
                    return window.location.replace(continueUrl);
                }
                router.push({name: 'Dashboard'})
            });
    }
}